<template>
  <div class="coach-page">
    <div class="section-background auto-height pb-0">
      <div class="container">
        <div class="hero">
          <div class="text">
            <div
              v-if="loading"
              class="loading-spinner"
            >
              <div
                class="spinner-border"
                role="status"
              >
                <span class="sr-only">Loading...</span>
              </div>
            </div>
            <div
              v-else
              class="flex"
            >
              <div class="profile-header">
                <div class="image">
                  <img
                    :src="coach.profile_pic"
                    :alt="fullname"
                  >
                </div>
                <div class="information">
                  <div class="name">
                    {{ fullname }}
                  </div>
                  <div class="keywords">
                    <span>
                      {{ coach.tag }}
                      <br>
                      {{ location }}
                    </span>
                    <br>
                    {{ coach.experience }} years of experience
                  </div>
                  <div class="cta">
                    <div class="price">
                      <p>1 Session</p>
                      <span>${{ coachFees }}</span>
                    </div>
                    <div class="buttons">
                      <b-button
                        variant="primary"
                        class="primary-button primary"
                        @click="hireCoach(1)"
                      >
                        Book now
                      </b-button>
                    </div>
                  </div>

                  <div class="cta">
                    <div class="price">
                      <p>3 Sessions</p>

                      <span>$ {{ coachFees3 }}</span>
                    </div>
                    <div class="buttons">
                      <b-button
                        variant="primary"
                        class="primary-button primary"
                        @click="hireCoach(3)"
                      >
                        Book now
                      </b-button>
                    </div>
                  </div>

                  <div class="cta">
                    <div class="price">
                      <p>5 Sessions</p>
                      <span>$ {{ coachFees5 }}</span>
                    </div>
                    <div class="buttons">
                      <b-button
                        variant="primary"
                        class="primary-button primary"
                        @click="hireCoach(5)"
                      >
                        Book now
                      </b-button>
                    </div>
                  </div>

                  <div class="session-description">
                    * a session includes analysis of <b>2 videos</b> of
                    <b>max. 3 minutes</b> each.
                  </div>
                </div>
              </div>
              <div class="profile-body">
                <div class="general-information">
                  <table>
                    <tr v-if="coach.specialism">
                      <td><h4>Specialism</h4></td>
                      <td>
                        <ul class="specs-list">
                          <li
                            v-for="(specialism, i) in coach.specialism
                              .specialism"
                            :key="i"
                            :value="specialism"
                          >
                            {{ specialism }}
                          </li>
                        </ul>
                      </td>
                    </tr>
                    <tr v-if="coach.certifications">
                      <td><h4>Certifications</h4></td>
                      <td>
                        <ul class="specs-list">
                          <li
                            v-for="(level, i) in coach.certifications
                              .certifications"
                            :key="i"
                            :value="level"
                          >
                            {{ level }}
                          </li>
                        </ul>
                      </td>
                    </tr>
                  </table>
                </div>
                <div class="bio">
                  <h4>About {{ firstname }}</h4>
                  <!-- eslint-disable-next-line -->
                  <div v-html="coach.description" />
                </div>
                <div
                  v-if="
                    coach.images &&
                      coach.images.images &&
                      coach.images.images.length
                  "
                  class="media-lib"
                >
                  <h4>{{ firstname }} in action</h4>

                  <div class="masonry">
                    <div
                      v-for="(chunk, i) in getImageChunks"
                      :key="i"
                      class="item"
                      :value="i"
                    >
                      <img
                        v-for="(image, j) in chunk"
                        :key="j"
                        :value="j"
                        :src="image"
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section-background padding-xl pt-0 auto-height">
      <div class="container">
        <div
          id="howItWorks"
          class="section-background auto-height"
        >
          <HowItWorks />
        </div>

        <div class="row usp-row">
          <div class="col-md-4">
            <div class="usp-holder">
              <i class="material-icons">sports_cricket</i>

              <p>Coaches You Can Trust</p>
              <span>All of our coaches have extensive coaching experience and are
                ICC, ECB, AUS, SA or BCCI certified coaches.</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="usp-holder">
              <i class="material-icons">account_balance_wallet</i>

              <p>Easy Booking & Payment</p>
              <span>Every coaching session can be booked in minutes through Ludimos
                and all financial transactions are securely processed
                online</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="usp-holder">
              <i class="material-icons">admin_panel_settings</i>

              <p>
                Good-Fit Guarantee
              </p>
              <span>We are committed to helping you find the right coach. Our
                coaches are world class and well qualififed to assit you to take
                you to the next level.
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CoachService from "@/services/coaches";
import HowItWorks from "./HowItWorks.vue";

import _ from "lodash";
export default {
  name: "CoachProfile",
  components: {
    HowItWorks,
  },

  data() {
    return {
      loading: true,
      coach: { user: {} },
    };
  },
  computed: {
    coachFees() {
      const fees = this.coach.fees ? this.coach.fees / 4 : 0;
      return fees ? `${fees.toFixed(2)}` : `Not Available`;
    },
    coachFees3() {
      let fees = this.coach.fees ? this.coach.fees / 4 : 0;
      fees = 3 * fees * 0.9;
      return fees ? `${fees.toFixed(2)}` : `Not Available`;
    },
    coachFees5() {
      let fees = this.coach.fees ? this.coach.fees / 4 : 0;
      fees = 5 * fees * 0.85;

      return fees ? `${fees.toFixed(2)}` : `Not Available`;
    },

    firstname() {
      return this.coach.user.firstname;
    },
    fullname() {
      return `${this.coach.user.firstname} ${this.coach.user.lastname}`;
    },
    location() {
      if (this.coach.city && this.coach.country) {
        return `${this.coach.city}, ${this.coach.country}`;
      }
      return "-";
    },
    getImageChunks() {
      return _.chunk(this.coach.images.images, 1);
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      const response = await CoachService.getCoach(this.$route.params.id, {
        _related: "user",
      });
      if (!response.data || response.data.status !== "APPROVED") {
        this.$router.push({ name: "error" });
        return;
      }
      this.coach = response.data ? response.data : this.coach;
      this.$ma.trackEvent({
        fb_event: "ViewContent",
        category: "Coach_Profile",
        action: "View",
        label: `${this.fullname}`,
        type: "View",
      });
      this.loading = false;
    },
    hireCoach(numSessions) {
      this.$router.push({
        name: "hire-coach-form",
        params: { id: this.coach.id },
        query: Object.assign(this.$route.query, { num_sessions: numSessions }),
      });
    },
  },
  metaInfo() {
    return {
      title: this.textEllipsis(`Coach ${this.fullname}`, 25),
      // meta: [{ name: "theme-color", content: this.getPrimaryHex }]
    };
  },
};
</script>
<style lang="scss" scoped>
.item {
  display: inline-block;
  margin: 0 10px 0 0;
  overflow: hidden;
  img {
    max-width: 100%;
    height: 200px;
  }
}

.profile-body {
  border-radius: 4px;
  padding: 20px;
  background: #f9f9f9;
}

.usp-row {
  text-align: center;
  margin: 30px 0;
  .usp-holder {
    border-radius: 10px;
    padding: 20px;
    background: #fff;
    background: linear-gradient(0deg, #e0d6ff 0%, #eee8ff 100%);
    color: #2b3060;
  }
  i {
    font-size: 100px;
    color: #6f44ff;
  }

  p {
    font-weight: bold;
    font-size: 20px;
  }
  span {
    font-size: 14px;
  }
}

.profile-header {
  min-width: 300px;
  margin-right: 40px;
  position: sticky;
  top: 80px;
  max-height: 700px;

  .image {
    min-width: 250px;
    max-width: 300px;
    margin-bottom: 20px;
    img {
      max-width: 100%;
      border-radius: 4px;
      box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.25);
    }
  }

  .information {
    .name {
      font-size: 25px;
      font-weight: 600;
    }

    .keywords {
      font-size: 14px;
    }

    .languages {
      margin: 15px 0 0;
      font-size: 12px;

      span {
        display: inline-block;
      }

      img {
        position: relative;
        top: -1px;
      }

      b {
        margin: 0 10px 0 5px;
        opacity: 0.5;
        font-weight: normal;
      }
    }
    .rating {
      color: #6e44ff;
      i {
        font-size: 20px;
      }
    }
  }

  .cta {
    border-radius: 4px;
    margin: 10px 0;
    padding: 10px;
    background: #f9f9f9;
    display: flex;
    align-items: center;
    .buttons {
      margin-left: auto;
      .primary-button {
        text-align: center;
        width: auto;
        min-width: 0;
      }
    }
  }
  .session-description {
    opacity: 0.5;
    font-size: 12px;
    margin: 10px 0;
  }
}

.price {
  p {
    margin: 0;
    font-size: 14px;
  }
  span {
    font-size: 24px;
    font-weight: bold;
    color: #00c088;
  }
}

ul.specs-list {
  li {
    margin: 0px 10px 10px 0;
    float: left;
    width: auto;
    &:after {
      content: "|";
      padding-left: 10px;
      opacity: 0.3;
    }
    &:last-child {
      &:after {
        content: none;
      }
    }
  }
}

h4 {
  margin: 20px 0 10px;
  border-top: 1px solid #eee;
  padding-top: 20px;
}

.general-information {
  table {
    display: block;
    tr {
      display: inline-block;
      vertical-align: top;
      width: 100%;
      margin: 0 0 10px;
      td {
        display: block;
        font-weight: normal;
        &:first-child {
          font-weight: 600;
        }
      }
      &:nth-child(1) {
        h4 {
          border-top: none;
          padding-top: 0;
          margin-top: 0;
        }
      }
    }
  }
}

.carousel-item {
  background: #f9f9f9;
  padding: 10px;
  img {
    width: calc(24.9% - 20px);
    margin: 10px;
    border-radius: 4px;
  }
}

.footer-buttons {
  text-align: center;
  button {
    min-width: 200px;
  }
}

@media (max-width: 767px) {
  .usp-holder {
    margin: 0 0 20px;
    span {
      display: none;
    }
  }

  .flex {
    display: block;
  }
  .profile-header {
    display: block;
    margin: 0;
    text-align: center;

    .image {
      margin: auto;
    }

    .information {
      margin: 20px 0 0;
      text-align: center;
    }

    .cta {
    }
  }

  .general-information {
    margin-top: 30px;

    h4 {
      margin-top: 0;
    }

    table {
      tr {
        width: 100%;
      }
    }
  }

  .price {
    text-align: center;

    span {
      display: inline-block;
    }
  }

  .item {
    max-width: 100%;
  }
}
</style>
